<template>
  <div class="ticket-details-display">
    <template v-if="!ticket.labels.includes('not-a-bug')">
      <div class="toolbar text-right">
        <p class="float-left">
          <span v-for="(label, index) in ticket.labels" class="badge" :key="index"
          v-if="label !== 'admin-issue' && label !== 'not-a-bug'"
          :class="{
            'badge-danger': label === 'High Priority',
            'badge-primary': label === 'In Development'
          }">{{ label }}</span>
        </p>
        <template v-if="isOpen">
          <button type="button" class="btn btn-primary" @click="executeAction('closeTicket')">
            <span class="fa fa-check-square"></span> Mark as Completed
          </button>
        </template>
        <template v-else>
          <button type="button" class="btn btn-primary" @click="executeAction('reopenTicket')">
            <span class="fa fa-ticket-alt"></span> Re-open Ticket
          </button>
        </template>
        <template v-if="ticket.labels.includes('High Priority')">
          <button type="button" class="btn btn-primary" @click="executeAction('removeTicketPriority')">
            <span class="fa fa-minus-circle"></span> Remove High Priority
          </button>
        </template>
        <template v-else>
          <button type="button" class="btn btn-primary" @click="executeAction('addTicketPriority')">
            <span class="fa fa-exclamation-circle"></span> Mark as High Priority
          </button>
        </template>
        <button type="button" class="btn btn-danger" @click="executeAction('deleteTicket')">
          <span class="fa fa-trash-alt"></span> Delete Ticket
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="card card-primary mb-2">
            <div class="card-header">
              <span class="fa fa-ticket-alt fa-fw"></span>
              #{{ ticket.iid }} - {{ ticket.title }}
              <span class="badge badge-success float-right">
                {{ isOpen ? 'Open' : 'Completed' }}
              </span>
            </div>
            <div class="card-body">
              <p><strong>Submitted: </strong> {{ ticket.created_at | date_format }}</p>
              <div v-html="nl2br(ticket.description)"></div>
            </div>
          </div>
        </div>
      </div>
      <template v-for="(note, index) in notes">
        <div class="row" v-if="!note.system && !note.body.includes('I could not re-create this issue')" :key="index">
          <div class="col-11 offset-1">
            <div class="card border-dark mb-2" :class="{ 'bg-light': index % 2 == 0 }">
              <div class="card-header">
                <span class="fa fa-fw fa-reply"></span>
                Response from {{ note.author.id !== 3 ? note.author.name : 'Admin' }}
              </div>
              <div class="card-body clearfix">
                <div v-html="nl2br(note.body)"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="card-footer text-right" v-if="isOpen">
        <button type="button" class="btn btn-primary" @click="reply()">
          <span class="fa fa-reply"></span> Reply
        </button>
      </div>
      <div v-else class="alert alert-danger">This issue has been marked as closed.</div>
    </template>
    <template v-else>
      <p class="callout callout-danger"><span class="fa fa-exclamation-triangle fa-fw"></span> Ticket has been deleted.</p>
    </template>
  </div>
</template>

<script>
import {
  LOAD_TICKET,
  CLOSE_TICKET,
  REOPEN_TICKET,
  DELETE_TICKET,
  ADD_TICKET_PRIORITY,
  REMOVE_TICKET_PRIORITY,
  OPEN_ERROR_MODAL,
  OPEN_MODAL
} from '@/vuex/types'
import { nl2br } from '@/util/filters'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TicketDetailsDisplay',
  components: {},
  computed: {
    notes () {
      return this.ticket.notes.reverse()
    },
    isOpen () {
      return this.ticket.state === 'opened'
    },
    ...mapGetters([
      'ticket'
    ])
  },
  async mounted () { await this.displayTicket() },
  watch: {
    async $route () { await this.displayTicket() }
  },
  methods: {
    nl2br (text) {
      return nl2br(text).replace('<img', '<img style="max-width:100%;"')
    },
    async executeAction (action) {
      try {
        await this[action](this.$route.params.ticketId)
        await this.displayTicket()
      } catch (err) {
        this.$store.dispatch(OPEN_ERROR_MODAL, err)
      }
    },
    async displayTicket () {
      try {
        await this.$store.dispatch(LOAD_TICKET, this.$route.params.ticketId)
      } catch (err) {
        this.$store.dispatch(OPEN_ERROR_MODAL, err)
      }
    },
    async reply () {
      await this.$store.dispatch(OPEN_MODAL, {
        permalink: 'replyTicket',
        params: this.$route.params,
        options: {
          title: 'Reply to Ticket',
          actionLabel: 'Reply'
        }
      })
    },
    ...mapActions([
      LOAD_TICKET,
      CLOSE_TICKET,
      REOPEN_TICKET,
      DELETE_TICKET,
      ADD_TICKET_PRIORITY,
      REMOVE_TICKET_PRIORITY
    ])
    // closeTicket () {
    //   let params = this.$route.params
    //   let { meta } = this.$route.matched.find(m => m.meta.authType)
    //   this.$http.post(`${meta.authType}/object/ticket/close`, params).then(({ data }, status, request) => {
    //     this.loadTicket()
    //   })
    // },
    // deleteTicket () {
    //   let params = this.$route.params
    //   let { meta } = this.$route.matched.find(m => m.meta.authType)
    //   this.$http.post(`${meta.authType}/object/ticket/delete`, params).then(({ data }, status, request) => {
    //     this.$router.push('/tickets')
    //   })
    // },
    // reopenTicket () {
    //   let params = this.$route.params
    //   let { meta } = this.$route.matched.find(m => m.meta.authType)
    //   this.$http.post(`${meta.authType}/object/ticket/reopen`, params).then(({ data }, status, request) => {
    //     this.loadTicket()
    //   })
    // },
    // removePriority () {
    //   let params = this.$route.params
    //   let { meta } = this.$route.matched.find(m => m.meta.authType)
    //   this.$http.post(`${meta.authType}/object/ticket/removePriority`, params).then(({ data }, status, request) => {
    //     this.loadTicket()
    //   })
    // },
    // addPriority () {
    //   let params = this.$route.params
    //   let { meta } = this.$route.matched.find(m => m.meta.authType)
    //   this.$http.post(`${meta.authType}/object/ticket/addPriority`, params).then(({ data }, status, request) => {
    //     this.loadTicket()
    //   })
    // },
    // replyModal () {
    //   this.replyingModal = true
    //   this.$nextTick(function () {
    //     $(this.$refs.replyModal).modal()
    //     $(this.$refs.replyModal).on('hidden.bs.modal', (e) => {
    //       this.replyingModal = false
    //     })
    //   })
    // },
    // reply () {
    //   let params = this.$route.params
    //   params.reply = this.replyMessage.value
    //   let { meta } = this.$route.matched.find(m => m.meta.authType)
    //   this.$http.post(`${meta.authType}/object/ticket/reply`, params).then(({ data }, status, request) => {
    //     $(this.$refs.replyModal).modal('toggle')
    //     this.loadTicket()
    //   })
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/TicketDetailsDisplay.vue